import { render, staticRenderFns } from "./KatalogBukuEdit.vue?vue&type=template&id=79d28663"
import script from "./KatalogBukuEdit.vue?vue&type=script&lang=js"
export * from "./KatalogBukuEdit.vue?vue&type=script&lang=js"
import style0 from "./KatalogBukuEdit.vue?vue&type=style&index=0&id=79d28663&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports